import ChatForwardCard from "../../../system/settings/components/ChatForwardCard";
import ChatForwardWhatsApp from "../../../system/settings/components/ChatForwardWhatsApp";


export default function ChatSettingsView() {


    return (
        <>
            <ChatForwardCard />
            <ChatForwardWhatsApp />
        </>
    )
}